import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import Swal from 'sweetalert2';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
// import Header from "../components/header/Header";
import Header from "../components/dashboard/header";


let { appname, lambda } = window.app;


const MyAccount = (props) => {
    const [user, setUser] = useState({ name: '', personalemail: '', phoneNumber: '' });
    const [errors, setErrors] = useState({});
    const [passwordInput, setPasswordInput] = useState({
        password: '',
        confirmPassword: '',
        oldPassword: ''
    });

    const [passwordError, setPasswordErr] = useState("");
    const [oldPasswordError, setOldPasswordError] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [passwordShown, setPasswordShown] = useState(true);
    const [isResendLoading, setIsResendLoading] = useState(false);
    const [number, setNumber] = useState(false);
    const [upper, setUpper] = useState(false);
    const [limit, setLimit] = useState(false);

    const [lower, setLower] = useState(false);
    const [special, setSpecial] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const [activeLoad, setActiveLoad] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        } else {
             fetchUserData();
        }
    }, [navigate]);

    const fetchUserData = async () => {

        try {
            const token = localStorage.getItem('token');
            const userId = localStorage.getItem('userId');

            const response = await axios.get(`${lambda}/userInfo?userId=${userId}&appname=${appname}`);
            if (response.data?.result === "User not found") {
                localStorage.removeItem("token");
                navigate('/signin');
            } else if (response.status === 200 && response.data?.result?.[0]) {
                setUser(response.data.result[0]);
            } else {
                throw new Error('Unexpected response format');
            }
        } catch (err) {
            console.error('Error fetching user data:', err);
            setError(err.message);
        }
    };


    const validate = () => {
        let validationErrors = {};
        if (!user.name) {
            validationErrors.name = 'Name is required';
        } else if (user.name.length < 2) {
            validationErrors.name = 'Name must be at least 2 characters';
        }
        if (user.phoneNumber && !/^\d{10}$/.test(user.phoneNumber)) {
            validationErrors.phoneNumber = 'Phone number is invalid';
        }
        return validationErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {

            try {
                setActiveLoad(true)
                const userid = localStorage.getItem('userId');
                const userType = localStorage.getItem('userType');
                const token = localStorage.getItem('token');
                const payload = {
                    name: user?.name,
                    phoneNumber: user?.phoneNumber,

                };
                await axios.post(`${lambda}/updateUser?appname=${appname}&userid=${userid}&userType=${userType}`, payload); // Replace with your updateUser API endpoint
                setActiveLoad(false)
                // Swal.fire({
                //     title: 'Success!',
                //     text: 'Profile updated successfully.',
                //     icon: 'success',
                //     confirmButtonText: 'OK'
                // });
                toast.success("Profile updated successfully.", {
                    position: "bottom-center",
                    title: 'Success!'
                });

            } catch (error) {
                setActiveLoad(false)
                // Swal.fire({
                //     title: 'Error!',
                //     text: 'Something went wrong. Please try again later.',
                //     icon: 'error',
                //     confirmButtonText: 'OK'
                // });
                toast.error("Error while updating the user details.", {
                    position: "bottom-center"
                });
            }

        } else {
            setActiveLoad(false)
            setErrors(validationErrors);
        }
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordInput(prevState => ({ ...prevState, [name]: value }));
    };
    const handleValidation = (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        //for password 
        if (passwordInputFieldName === 'password' || passwordInputFieldName === 'oldPassword') {
            const uppercaseRegExp = /(?=.*?[A-Z])/;
            const lowercaseRegExp = /(?=.*?[a-z])/;
            const digitsRegExp = /(?=.*?[0-9])/;
            const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
            const minLengthRegExp = /.{8,}/;
            const passwordLength = passwordInputValue.length;
            const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
            const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
            const digitsPassword = digitsRegExp.test(passwordInputValue);
            const specialCharPassword = specialCharRegExp.test(passwordInputValue);
            const minLengthPassword = minLengthRegExp.test(passwordInputValue);
            let errMsg = "";
            if (passwordLength === 0) {
                errMsg = "Password is empty";
                setTimeout(() => setPasswordErr(""), 4000);

            }
            // else if (!uppercasePassword) {
            //     errMsg = "At least one Uppercase";
            // } else if (!lowercasePassword) {
            //     errMsg = "At least one Lowercase";
            // } else if (!digitsPassword) {
            //     errMsg = "At least one digit";
            // } else if (!specialCharPassword) {
            //     errMsg = "At least one Special Characters";
            // } else if (!minLengthPassword) {
            //     errMsg = "At least minumum 8 characters";
            // } else {
            //     errMsg = "";
            // }
            if (uppercasePassword) {
                var element = document.getElementById("err1");
                element.classList.add("vaild");
                setUpper(true);
            } else {
                var element = document.getElementById("err1");
                element.classList.remove("vaild");
                setUpper(false);
            }
            if (lowercasePassword) {
                var element = document.getElementById("err");
                element.classList.add("vaild");
                setLower(true);
            } else {
                var element = document.getElementById("err");
                element.classList.remove("vaild");
                setLower(false);
            }
            if (digitsPassword) {
                var element = document.getElementById("err2");
                element.classList.add("vaild");
                setNumber(true);
            } else {
                var element = document.getElementById("err2");
                element.classList.remove("vaild");
                setNumber(false);
            }
            if (specialCharPassword) {
                var element = document.getElementById("err3");
                element.classList.add("vaild");
                setSpecial(true)
            } else {
                var element = document.getElementById("err3");
                element.classList.remove("vaild");
                setSpecial(false)
            }
            if (minLengthPassword) {
                var element = document.getElementById("err4");
                element.classList.add("vaild");
                setLimit(true)
            } else {
                var element = document.getElementById("err4");
                element.classList.remove("vaild");
                setLimit(false)
            }

            if (limit && upper && special && lower && number && confirmPasswordError === "") {
                setError("")
            }

            setPasswordErr(errMsg);
        }
        // for confirm password
        // if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {

        //     if (passwordInput?.confirmPassword !== passwordInput?.password) {
        //         setConfirmPasswordError("Confirm password is not matched");
        //     } else {
        //         setConfirmPasswordError("");
        //     }

        // }
    }
    const handleRemoveclass = (evnt) => {
        var element = document.getElementById("instruction");
        element.classList.remove("ins-dsp-none");
    }
    // const handleValidation = (e) => {
    //     const { name, value } = e.target;
    //     const uppercaseRegExp = /(?=.*?[A-Z])/;
    //     const lowercaseRegExp = /(?=.*?[a-z])/;
    //     const digitsRegExp = /(?=.*?[0-9])/;
    //     const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
    //     const minLengthRegExp = /.{8,}/;

    //     if (name === 'password' || name === 'oldPassword') {
    //         setPasswordError(value.length === 0 ? "Password is empty" : "");
    //         setUpper(uppercaseRegExp.test(value));
    //         setLower(lowercaseRegExp.test(value));
    //         setNumber(digitsRegExp.test(value));
    //         setSpecial(specialCharRegExp.test(value));
    //         setLimit(minLengthRegExp.test(value));
    //     }

    //     if (name === 'confirmPassword' && value !== passwordInput.password) {
    //         setConfirmPasswordError("Confirm password does not match");
    //     } else {
    //         setConfirmPasswordError("");
    //     }
    // };

    const handleFocus = (e) => {
        const { name } = e.target;
        setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    };
    const handleAddclass = (evnt) => {
        var element = document.getElementById("instruction");
        element.classList.add("ins-dsp-none");
        setConfirmPasswordError("");
    }

    const handlePwdGenerate = (e) => {
        e.preventDefault();
        if (user?.userpwd?.length > 0) {
            if (passwordInput?.password == "") {
                setError("Please Enter Password");
                setTimeout(function () { setError("") }, 3000);

            } else if (passwordInput?.confirmPassword == "") {
                setError("Please Enter Confirm Password");
                setTimeout(function () { setError("") }, 3000);

            } else if (passwordInput?.oldPassword == "") {
                setError("Please Enter Old Password");
                setTimeout(function () { setError("") }, 3000);

            } else if (passwordInput?.oldPassword == passwordInput?.password) {
                setError("old and new passwords are must not be same");
                setTimeout(function () { setError("") }, 3000);

            }


            else if (passwordInput.confirmPassword !== passwordInput.password) {
                setConfirmPasswordError("Confirm password does not match");
                setTimeout(() => setError(""), 4000);
            } else if (!limit || !upper || !special || !lower || !number) {
                setError("Please enter the password as per the instructions");
                setTimeout(() => setError(""), 4000);
            } else {
                pwdGenerate();
            }
        } else {
            if (passwordInput?.password == "") {
                setError("Please Enter Password");
                setTimeout(function () { setError("") }, 3000);

            } else if (passwordInput?.confirmPassword == "") {
                setError("Please Enter Confirm Password");
                setTimeout(function () { setError("") }, 3000);

            } else if (passwordInput.confirmPassword !== passwordInput.password) {
                setConfirmPasswordError("Confirm password does not match");
                setTimeout(() => setError(""), 4000);
            } else if (!limit || !upper || !special || !lower || !number) {
                setError("Please enter the password as per the instructions");
                setTimeout(() => setError(""), 4000);
            } else {
                pwdGenerate();
            }
        }
    };

    const handleConfirm = (evnt) => {
        const passwordInputFieldName = evnt.target.name;
        if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {

            // if (passwordInput?.confirmPassword !== passwordInput?.password) {
            //     setConfirmPasswordError("Confirm password is not matched");
            // } else {
            //     setConfirmPasswordError("");
            // }

        }
    }
    const pwdGenerate = async () => {
        console.log("Processing password change...");
        // const clientid = localStorage.getItem('clientid');
        const userid = localStorage.getItem('userId');
        const userType = localStorage.getItem('userType');
        const token = localStorage.getItem('token');
        try {
            setIsResendLoading(true)
            const isChangePwd = user?.userpwd?.length > 0;

            const payload = {
                emailid: user.emailid,
                password: passwordInput.password,
                ...(isChangePwd && { oldPassword: passwordInput.oldPassword })
            };

            const response = await axios.post(
                `${lambda}/setPassword?appname=${appname}&userid=${userid}&userType=${userType}`,
                payload
            );



            if (response.data.result === "old password is wrong") {
                setIsResendLoading(false)
                setError("Old password is incorrect");
                setTimeout(() => setError(""), 4000);
            } else if (response?.data?.result?.emailid) {
                setIsResendLoading(false)
                // Swal.fire({
                //     title: 'Success!',
                //     text: user?.userpwd ? 'Password changed successfully.' : 'Password created successfully.',
                //     icon: 'success',
                //     confirmButtonText: 'OK'
                toast.success(user?.userpwd ? 'Password changed successfully.' : 'Password created successfully.', {
                    position: "bottom-center",
                    title: 'Success!'
                });


                setPasswordInput({
                    password: '',
                    confirmPassword: '',
                    oldPassword: ''
                })
                // fetchUserData()

            } else {
                setIsResendLoading(false)
                setError("Something went wrong. Please try again.");

            }

            setActiveLoad("");
        } catch (error) {
            setIsResendLoading(false)
            setActiveLoad("");
            setError("Something went wrong. Please try again.");

        }
    };


    const [activeTab, setActiveTab] = useState('myaccount');


    return (

        <main>
            <Header />
            <div className="wrapper quiz_page">
                <div id="account-page-container">
                    <div id="page-top">
                        {/* <InsideHeader flag={true} id="inside-header" /> */}
                        <ToastContainer position="bottom-right" id="toast-container" />


                        <div style={{ display: 'flex', gap: '20px', borderBottom: '1px solid #ccc' }}>
                            <div
                                onClick={() => setActiveTab('myaccount')}
                                style={{
                                    padding: '10px',
                                    cursor: 'pointer',
                                    borderBottom: activeTab === 'myaccount' ? '2px solid blue' : 'none'
                                }}
                            >
                                my account
                            </div>
                            <div
                                onClick={() => setActiveTab('password')}
                                style={{
                                    padding: '10px',
                                    cursor: 'pointer',
                                    borderBottom: activeTab === 'password' ? '2px solid blue' : 'none'
                                }}
                            >
                                password
                            </div>

                        </div>

                        {/* Static Tab Content */}
                        <div style={{ padding: '20px' }}>
                            {activeTab === 'myaccount' && <div className="card" id="account-card">
                                <div className="card-body">
                                    <h1 id="my-account-title">My Account</h1>
                                    <form onSubmit={handleSubmit} id="account-form">
                                        <div className="row" id="form-row">
                                            <div className="col-md-4" id="name-field">
                                                <div className="form-group" id="name-group">
                                                    <label htmlFor="name-input" id="name-label">Name</label>
                                                    <input
                                                        id="name-input"
                                                        type="text"
                                                        name="name"
                                                        value={user.name}
                                                        onChange={(e) => setUser({ ...user, name: e.target.value })}
                                                        onFocus={handleFocus}
                                                        className="form-control"
                                                    />
                                                    {errors.name && <div className="text-danger" id="name-error">{errors.name}</div>}
                                                </div>
                                            </div>
                                            <div className="col-md-4" id="email-field">
                                                <div className="form-group" id="email-group">
                                                    <label htmlFor="email-input" id="email-label">Email</label>
                                                    <input
                                                        id="email-input"
                                                        type="email"
                                                        name="personalemail"
                                                        value={user.emailid}
                                                        disabled
                                                        className="form-control"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4" id="phone-field">
                                                <div className="form-group" id="phone-group">
                                                    <label htmlFor="phone-input" id="phone-label">Phone Number</label>
                                                    <input
                                                        id="phone-input"
                                                        type="text"
                                                        name="phoneNumber"
                                                        value={user.phoneNumber}
                                                        onChange={(e) => {
                                                            const onlyDigits = e.target.value.replace(/\D/g, "");
                                                            setUser({ ...user, phoneNumber: onlyDigits });
                                                        }}
                                                        onFocus={handleFocus}
                                                        className="form-control"
                                                    />
                                                    {errors.phoneNumber && <div className="text-danger" id="phone-error">{errors.phoneNumber}</div>}
                                                </div>
                                            </div>
                                            <div className="row mt-2" id="submit-row">
                                                <div className="col-md-12" id="submit-button">
                                                    <button type="submit" className="btn gradietn_btn rounded-pill" id="update-button">
                                                        {activeLoad && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                                        Update
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>}
                            {activeTab === 'password' && <div className="card mt-3" id="password-card">
                                <div className="card-body">
                                    <div className="change-password" id="change-password-section">
                                        <h1 id="password-title">
                                            {user?.userpwd?.length > 0 ? "Change Password" : "Create Password"}
                                        </h1>
                                        <div className="row" id="password-row">
                                            <div className="col-md-7" id="password-left">
                                                {user?.userpwd?.length > 0 && (
                                                    <div className="col-md-12" id="old-password-field">
                                                        <div className="form-group" id="old-password-group">
                                                            <label htmlFor="old-password-input" id="old-password-label">Old Password</label>
                                                            <input
                                                                id="old-password-input"
                                                                type={passwordShown ? "text" : "password"}
                                                                name="oldPassword"
                                                                value={passwordInput.oldPassword}
                                                                onChange={handlePasswordChange}
                                                                className="form-control"
                                                            />
                                                            <p className="text-danger" id="old-password-error">{oldPasswordError}</p>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="col-md-12" id="new-password-field">
                                                    <div className="form-group" id="new-password-group">
                                                        <label htmlFor="new-password-input" id="new-password-label">New Password</label>
                                                        <input
                                                            id="new-password-input"
                                                            type={passwordShown ? "text" : "password"}
                                                            name="password"
                                                            value={passwordInput.password}
                                                            onChange={handlePasswordChange}
                                                            onKeyUp={handleValidation}
                                                            onBlur={(e) => handleAddclass(e)}
                                                            onFocus={(e) => handleRemoveclass(e)}
                                                            className="form-control"
                                                        />
                                                        <p className="text-danger" id="new-password-error">{passwordError}</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-12" id="confirm-password-field">
                                                    <div className="form-group" id="confirm-password-group">
                                                        <label htmlFor="confirm-password-input" id="confirm-password-label">Confirm Password</label>
                                                        <input
                                                            id="confirm-password-input"
                                                            type={passwordShown ? "text" : "password"}
                                                            name="confirmPassword"
                                                            value={passwordInput.confirmPassword}
                                                            onChange={handlePasswordChange}
                                                            onKeyUp={handleConfirm}
                                                            onBlur={(e) => handleAddclass(e)}
                                                            onFocus={(e) => handleRemoveclass(e)}
                                                            className="form-control"
                                                        />
                                                        <p className="text-danger" id="confirm-password-error">{confirmPasswordError}</p>
                                                    </div>
                                                </div>
                                                <div className="col-md-12" id="show-password-field">
                                                    <div className="form-group d-flex align-items-center check_box" id="show-password-group">
                                                        <input
                                                            id="showPassword"
                                                            type="checkbox"
                                                            onChange={() => setPasswordShown(!passwordShown)}
                                                        />
                                                        <label htmlFor="showPassword" id="show-password-label">Show Password</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-12" id="password-submit">
                                                    <button
                                                        id="password-submit-button"
                                                        onClick={handlePwdGenerate}
                                                        className="btn gradietn_btn rounded-pill"
                                                    >
                                                        {isResendLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                                        {user?.userpwd?.length > 0 ? 'Change Password' : 'Create Password'}
                                                    </button>
                                                    {error && <p className="text-danger" id="password-error">{error}</p>}
                                                </div>
                                            </div>
                                            <div className="col-md-5" id="password-instructions">
                                                <div className="create-password-instruction ins-dsp-none" id="instruction">
                                                    <p className="error" id="err">{lower ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a lower case letter</p>
                                                    <p className="error" id="err1">{upper ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain an upper case letter</p>
                                                    <p className="error" id="err2">{number ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a number</p>
                                                    <p className="error" id="err3">{special ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain a special character or a space</p>
                                                    <p className="error" id="err4">{limit ? <span className="material-symbols-outlined">check</span> : <span className="material-symbols-outlined">close</span>} Password must contain at least 8 characters</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </div>




                    </div>


                </div>
            </div>
            <Footer id="footer-component" />
        </main>

    );
};

export default MyAccount;